import { useApplicationModals } from "app/common/hooks";
import { useCollector } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";
import Table from "app/components/atoms/table";
import { SearchInput } from "app/components/atoms/input";
import { IconButton } from "app/components/atoms/button";
import { PrinterIcon } from "@heroicons/react/24/solid";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import {
  filter as _filter,
  findWhere as _findWhere,
  flatten as _flatten,
  where as _where,
} from "underscore";

const breadcrumbItems = [
  { label: "Settings", href: "#" },
  { label: "Product Variant", href: "#" },
];

function ProductPage() {
  const { openModal, setPayloads } = useApplicationModals();

  const [productVariants, setVariants, loader, collect] = useCollector({
    modelName: "productVariant",
  });

  return (
    <MainLayout
      activeSidebarNavigation="settings"
      activeSidebarChild="productVariant"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Product Variant"
      headingButtons={[
        {
          label: "Add Product Variant",
          type: "button",
          onClick: () => openModal("productVariant.create"),
        },
      ]}
    >
      <AppModals
        items={[
          "productVariant.create",
          "productVariant.update",
          "productVariant.delete",
        ]}
        onSuccess={{
          "productVariant.create": () => collect(),
          "productVariant.update": () => collect(),
          "productVariant.delete": () => collect(),
        }}
      />
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <Table.SearchBarItemWrapper>
              {/* <SearchInput placeholder="Search" /> */}
            </Table.SearchBarItemWrapper>
          </Table.SearchBarWrapper>
          {/* <Table.UtilitiesButtonWrapper>
            <IconButton icon={PrinterIcon} />
          </Table.UtilitiesButtonWrapper> */}
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Code</Table.Heading>
              <Table.Heading>Name</Table.Heading>
              <Table.Heading>Size</Table.Heading>
              <Table.Heading>Color</Table.Heading>
              <Table.Heading>Price</Table.Heading>
              <Table.Heading></Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {productVariants?.map((productVariant, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>{productVariant?.product_detail?.code}</Table.Cell>
                <Table.Cell>{productVariant?.product_detail?.name}</Table.Cell>
                <Table.Cell>{productVariant?.size?.name}</Table.Cell>
                <Table.Cell>{productVariant?.color?.name}</Table.Cell>
                <Table.Cell>{productVariant?.product_detail?.price}</Table.Cell>
                <Table.Cell>
                  {/* <div className="flex">
                    <IconButton
                      icon={PencilSquareIcon}
                      onClick={(e) => {
                        setPayloads("productVariant.update", {
                          id: productVariant.id,
                        });
                        openModal("productVariant.update");
                      }}
                    />
                    <IconButton
                      icon={TrashIcon}
                      onClick={(e) => {
                        setPayloads("productVariant.delete", {
                          id: productVariant.id,
                        });
                        openModal("productVariant.delete");
                      }}
                    />
                  </div> */}
                </Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default ProductPage;
